module.exports = __webpack_public_path__ + "static/media/grommet-icons_transaction.e5b65b22.svg";